import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LucideAngularModule, AlertTriangle } from 'lucide-angular';
import { ConfirmModalService } from '../../../services/confirm-modal.service';
import { ButtonComponent } from '../button/button.component';

/**
 * Global confirmation modal bound to `ConfirmModalService` state.
 */
@Component({
  selector: 'app-confirm-modal',
  imports: [LucideAngularModule, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.css',
})
export class ConfirmModalComponent {
  /** Shared modal state and resolver methods. */
  readonly svc = inject(ConfirmModalService);

  /** Warning icon shown in the modal header. */
  readonly AlertTriangleIcon = AlertTriangle;
}
